import React, { Component } from "react";
import classnames from "classnames";
import styles from "./Components.local.scss";
import { number_format } from "Utils";
import Percentage from "../../Common/Percentage/Percentage";
import ComponentActions from "./ComponentActions";

class IllustrativeProgressBarsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      progressBarsWidth: ["0%", "0%", "0%", "0%", "0%", "0%"]
    };
  }

  componentDidMount() {
    const { component } = this.props;

    const {
      data: { accounts }
    } = component;

    this.calculateProgressBarsWidth(accounts);
  }

  calculateProgressBarsWidth = accounts => {
    setTimeout(() => {
      this.setState({
        progressBarsWidth: accounts.map(
          e =>
            parseFloat(e.progressBarWidth) <= 20 ? "20%" : e.progressBarWidth
        )
      });
    }, 600);
  };

  renderBlocs = (accounts, customBackground) => {
    let blocs = [];
    for (let i = 0; i < accounts.length; i++) {
      blocs.push(
        <div
          key={i}
          className={classnames(
            "medium-12 small-12",
            styles.bloc,
            styles.flex_container
          )}
          style={customBackground}
        >
          <span className={styles.bloc_title}>{accounts[i].label}</span>
          <span
            className={classnames(
              styles.bloc_percentage_span,
              accounts[i].percentage < 0 && accounts[i].percentage >= -5
                ? styles.orange_percentage
                : ""
            )}
          >
            <Percentage percentage={accounts[i].percentage} />
          </span>

          <div
            className={classnames(
              "medium-12 small-12",
              styles.flex_container,
              styles.bloc_progressBar
            )}
          >
            <span
              className={classnames(
                styles.current_filled_value,
                accounts[i].percentage < -5
                  ? styles.danger_bar
                  : accounts[i].percentage < 0
                    ? styles.warning_bar
                    : styles.default_bar
              )}
              style={{ width: this.state.progressBarsWidth[i] }}
            >
              <span>
                &nbsp;&nbsp;{" "}
                {accounts[i].notAvailable
                  ? "N/A"
                  : number_format(accounts[i].currentValue, 2, ",", " ")}{" "}
                {accounts[i].unit !== "none" ? accounts[i].unit : ""}
              </span>
            </span>

            <span className={styles.last_year_value_indicator}>
              {accounts[i].notAvailable
                ? "N/A"
                : number_format(accounts[i].lastYearValue, 2, ",", " ")}{" "}
              {accounts[i].unit !== "none" ? accounts[i].unit : ""}
            </span>

            <span className={styles.last_year}>N-1</span>
          </div>
        </div>
      );
    }
    return blocs;
  };

  render() {
    const {
      component,
      layoutProps: {
        customBackground
        // scaleComponent
      }
      // isResponsive
    } = this.props;

    const {
      data: { accounts }
    } = component;

    return (
      <div>
        <div
          className={classnames(
            styles.IllustrativeProgressBarsComponent,
            styles.absolute_container,
            styles.flex_container
            // isResponsive && scaleComponent ? styles.scale_component : null
          )}
        >
          {!this.props.inSlideView && (
            <ComponentActions
              removeComponent={this.props.handleRemoveComponent}
              updateComponent={this.props.handleUpdateComponent}
              componentCase={this.props.ComponentCase}
              sideBar={"MultiIndicatorComponentConfig"}
              component={"IllustrativeProgressBarsComponent.png"}
            />
          )}
          {this.renderBlocs(accounts, customBackground)}
        </div>
      </div>
    );
  }
}

export default IllustrativeProgressBarsComponent;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/IllustrativeProgressBarsComponent.js